var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"te-popover"}},[(_vm.show)?_c('div',{class:_vm.getClasses(),style:(_vm.getStyle()),on:{"click":_vm.doThis}},[_c('div',{staticClass:"te-popover-wrapper"},[_c('div',{staticClass:"te-popover-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"te-popover-content"},[_vm._t("default")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }